import * as React from 'react';

const VerifiedIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_18977_71924"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_18977_71924)">
      <path
        d="M14.6 17.4207L12.477 15.2974C12.2786 15.0992 12.0464 14.998 11.7807 14.9937C11.5149 14.9895 11.2786 15.0908 11.0717 15.2974C10.865 15.5043 10.7617 15.742 10.7617 16.0104C10.7617 16.2786 10.865 16.5162 11.0717 16.7231L13.7563 19.4284C13.9974 19.6693 14.2787 19.7897 14.6 19.7897C14.9213 19.7897 15.2026 19.6693 15.4437 19.4284L20.9693 13.9028C21.1676 13.7043 21.2688 13.4687 21.273 13.1961C21.2772 12.9236 21.176 12.684 20.9693 12.4771C20.7624 12.2702 20.5248 12.1667 20.2563 12.1667C19.9881 12.1667 19.7506 12.2702 19.5437 12.4771L14.6 17.4207ZM16 28.4947C15.8616 28.4947 15.7257 28.4836 15.5923 28.4614C15.459 28.4392 15.3299 28.4059 15.205 28.3614C12.3932 27.3614 10.1561 25.5884 8.49367 23.0424C6.83122 20.4962 6 17.7487 6 14.8001V8.79508C6 8.29064 6.14622 7.83553 6.43867 7.42975C6.73089 7.02375 7.10689 6.7293 7.56667 6.54642L15.1563 3.71308C15.4419 3.61042 15.7231 3.55908 16 3.55908C16.2769 3.55908 16.5581 3.61042 16.8437 3.71308L24.4333 6.54642C24.8931 6.7293 25.2691 7.02375 25.5613 7.42975C25.8538 7.83553 26 8.29064 26 8.79508V14.8001C26 17.7487 25.1688 20.4962 23.5063 23.0424C21.8439 25.5884 19.6068 27.3614 16.795 28.3614C16.6701 28.4059 16.541 28.4392 16.4077 28.4614C16.2743 28.4836 16.1384 28.4947 16 28.4947Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default React.memo(VerifiedIcon);
